module.exports = __webpack_public_path__ + "media/images/river/classic-abbf762e2acfaa054e2b61a8ef51e42c.png";